export { default as ClockStopwatchIcon } from './clock-stopwatch.svg';
export { default as SaleIcon } from './saleicon.svg';
export { default as CheckmarkIcon } from './checkmark.svg';
export { default as CreditCardIcon } from './credit-card-refresh.svg';
export { default as Calendar } from './calendar-check-02.svg';
export { default as HomeIcon } from './homeicon.svg';
export { default as SylndrSwift } from './SylndrSwift.svg';
export { default as DownloadAppAnimation } from './downloadApp.gif';
